import { Layout, Space } from 'antd';
import classNames from 'classnames';
import { useLayoutStyles } from '../layout/styles';
import logo from '~/assets/symbol.png';
import { CommonLayout } from '~/layout/CommonLayout';

const { Header } = Layout;

export const GuestLayout = ({
  partnerName,
  title,
  children,
  flexibleWidth = false,
}: React.PropsWithChildren<{ partnerName: string; title: string; flexibleWidth?: boolean }>) => {
  const classes = useLayoutStyles();

  return (
    <CommonLayout
      flexibleWidth={flexibleWidth}
      title={title}
      pageLoading={false}
      hideFooter={true}
      hideSidebar={true}
      header={
        <Header className={classes.header}>
          <Space>
            <img src={logo} alt={'Shipium'} title="Shipium" style={{ width: '36px' }} />
            <h3 style={{ margin: 0 }}>
              <span className={classNames(classes.partnerName)}>
                {partnerName} | {title}
              </span>
            </h3>
          </Space>
        </Header>
      }
    >
      {children}
    </CommonLayout>
  );
};

export default GuestLayout;
